import React, { useState, useEffect } from "react"
import { Link, navigate } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Header from "../components/header"
import "./404.css"

const resolveFeatureFlag = (flagValue, enabledByMode) => {
  if (flagValue === "true") return true
  if (flagValue === "false") return false
  return enabledByMode
}

function NotFoundPage() {
  const [countdown, setCountdown] = useState(8)
  const [isPaused, setIsPaused] = useState(false)
  const siteMode = process.env.GATSBY_SITE_MODE || process.env.GATSBY_siteType || "booking"
  const isServicesEnabled = resolveFeatureFlag(
    process.env.GATSBY_ENABLE_SERVICES,
    siteMode !== "cart"
  )

  useEffect(() => {
    if (isPaused) return

    const intervalId = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(intervalId)
          navigate("/")
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(intervalId)
  }, [isPaused])

  return (
    <Layout>
      <Seo title="Página no encontrada" path="/404" noindex />
      <Header showCollapsed={true} />
      <div className="notfound-page">
        <div className="notfound-content">
          <div className="notfound-code">404</div>
          <h1 className="notfound-title">Esta página no existe</h1>
          <p className="notfound-message">
            El enlace que seguiste puede estar roto o la página ya no está
            disponible. Aquí tienes algunas opciones para continuar:
          </p>

          {/* H10 + H6 - Links útiles para reconocimiento y navegación */}
          <div className="notfound-links">
            <Link to="/" className="notfound-primary-btn">
              Ir al inicio
            </Link>
            <Link to="/#productos" className="notfound-secondary-btn">
              Ver productos
            </Link>
            {isServicesEnabled && (
              <Link to="/#servicios" className="notfound-secondary-btn">
                Ver servicios
              </Link>
            )}
          </div>

          {/* H3 - Control del usuario: cancelar redirección */}
          {!isPaused ? (
            <div className="notfound-redirect">
              <p>
                Te llevaremos al inicio en <strong>{countdown}</strong>{" "}
                {countdown === 1 ? "segundo" : "segundos"}
              </p>
              <button
                className="notfound-cancel-btn"
                onClick={() => setIsPaused(true)}
              >
                Cancelar redirección
              </button>
            </div>
          ) : (
            <p className="notfound-paused">
              Usa los botones de arriba para navegar.
            </p>
          )}
        </div>
      </div>
    </Layout>
  )
}

export default NotFoundPage
